<template>
  <div class="tw-border tw-border-gray dark:tw-border-dm-gray tw-overflow-hidden tw-rounded-3xl">
    <template
      v-for="(company, index) in companies"
      :key="company.id"
    >
      <div
        v-if="index > 0"
        class="tw-w-full tw-h-px tw-bg-gray dark:tw-bg-dm-gray"
      />
      <AddClientsCompaniesListItem
        :company="company"
        @close="$emit('close')"
        @select-company="(selectedCompany) => $emit('select-company', selectedCompany)"
      />
    </template>
  </div>
</template>

<script>
import AddClientsCompaniesListItem
  from '@/components/Administration/Client/Companies/AddClientsCompaniesListItem.vue';
import { mapState } from 'vuex';

export default {
  name: 'AddClientsCompaniesList',
  components: {
    AddClientsCompaniesListItem,
  },
  computed: {
    ...mapState({
      companies: (state) => state.v2.admin.cms.clients.companies.companiesByNameOrIco,
    }),
  },
};
</script>
